const links = [
    {
        label: 'Fertilidade',
        url: '/fertilidade'
    },
    {
        label: 'Gestação',
        url: '/gestacao'
    },
    {
        label: 'Pós Parto',
        url: '/pos-parto'
    },
]

export default links;